import type { FaireProductEntity } from "../../entity_types/product";

export const p_kn4qbt59zj: FaireProductEntity = {
  token: "p_kn4qbt59zj",
  type: "product",
  name: "Airheads Soda Strawberry 12 Count",
  brandToken: "b_6w2wcf7tpu",
  brandName: "Mr. YuYu's Chililicious Candy",
  imageUrl:
    "https://cdn.faire.com/fastly/79a69b93fe0d141d6c5f0b0a3514d58f345e83d2b0b2f1baceb12e6a358bce95.jpeg",
  galleryImageUrls: [],
  priceDollars: 29.76,
  description:
    "Enjoy the sweet, fizzy delight of Airheads Soda Strawberry 12 Count, available exclusively from Mr. YuYu’s Wholesale. Each bottle delivers a refreshing burst of fruity strawberry flavor paired with a perfect balance of sweetness and carbonation.\n\nCrafted with real cane sugar and no artificial colors, this soda offers a premium, nostalgic beverage experience for those who love bold, candy-inspired drinks. Ideal for parties, retail shelves, or personal refreshment, this 12-count pack ensures you’ll always have your favorite Airheads Soda on hand.\n\nKey Features:\n\n * 12-count pack of Airheads Strawberry Soda \n * Made with real cane sugar, no artificial colors \n * Sweet and bubbly strawberry flavor inspired by the classic candy \n * Perfect for on-the-go refreshment, gatherings, or resale \n * From Mr. YuYu’s Wholesale – your trusted source for rare and exotic beverages ",
  tags: [],
  msrpDollars: 59.53,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:55.600Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
